// extracted by mini-css-extract-plugin
module.exports = {"listItem":"index-module--listItem--3LpgN","iphoneCase":"index-module--iphoneCase--ca-WT","gifDevice":"index-module--gifDevice--1gQJP","gif":"index-module--gif--23aXD"};